<template>
    <div>
      <Loading :value="loading"></Loading>
      <v-layout row>
        <v-flex xs12>
          <v-card color="" class="mb-5" flat>
            <v-layout wrap>
              <v-flex md12>
               
                <v-alert :value="true" outline color="purple" icon="info">
                 ANALYSE DU JOURNAL DES DONNEES
                </v-alert>
                <br>
                <v-layout row class="elevation-12 pt-1 mb-3">
                  <v-flex xs12 class="text-xs-center">
                        <h3>Critères de recherche </h3>
                        <v-divider class="mb-2"></v-divider>
                          <el-form :inline="true" :model="formTri" id="formTri" class="demo-form-inline">

                              <el-form-item label="Projet">
                                  <el-select v-on:change="onchangeInfo(selectProjet)" filterable clearable v-model="selectProjet" placeholder="Projet">
                                      <el-option
                                              v-for="item in listeProjet"
                                              :key="item.id"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Chantier" >
                                  <el-select clearable v-on:change="loadTravaux();onchangeChantier(selectChantier)" v-model="selectChantier" placeholder="Chantier">
                                      <el-option
                                              v-for="item in listeChantier"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item>

                              <el-form-item label="Section" >
                                  <el-select clearable v-model="selectTravaux" v-on:change="loadTaches();onChangeTravaux(selectTravaux)" placeholder="Travaux">
                                      <el-option
                                              v-for="item in listeTravaux"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Tâche" >
                                  <el-select clearable v-model="selectTaches" placeholder="Tâche">
                                      <el-option
                                              v-for="item in listTaches"
                                              :key="item.value"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>
                              </el-form-item> 

                              <el-form-item label="Période">
                                  <el-date-picker
                                  style="width: 100%"
                                  v-model="selectAnnee"
                                  format="dd-MM-yyyy"
                                  value-format="yyyy-MM-dd"
                                  type="datetimerange"
                                  range-separator="à"
                                  start-placeholder="Début date"
                                  end-placeholder="Fin date"
                                  ></el-date-picker>
                              </el-form-item>

                              <el-form-item label="Type de recherche">
                                <el-select clearable v-model="typeRech" placeholder="Type de recherche">
                                      <el-option
                                              v-for="item in listeTypeRech"
                                              :key="item.id"
                                              :label="item.libelle"
                                              :value="item.id">
                                      </el-option>
                                  </el-select>                         
                              </el-form-item> 

                              <el-form-item label="">
                                  <v-tooltip bottom>
                                      <v-btn @click="loadChantierSearch()" slot="activator" class="white--text" color="blue" fab small>
                                          <v-icon>search</v-icon>
                                      </v-btn>Effectuer une recherche
                                  </v-tooltip>
                              </el-form-item>
                          </el-form>
                    </v-flex>
                </v-layout>
              
                <br/>
                <v-chip style="border-radius: 16px;"  class="text-align:center" text-color="white" label color="primary"> TABLEAU RECAPITULATIF DES MAINS D'ŒUVRES </v-chip>
                <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.listeParticipants && listTravauxResult.listeParticipants.length >0">
                    <v-tooltip top>
                      <v-btn
                          slot="activator"
                          color="orange"
                          @click.stop="dialogueImprimer=true;type='ALL'"
                          dark
                      >
                        Exporter en Pdf tous les tableaux
                          <v-icon right>print</v-icon>
                      </v-btn>Pdf
                    </v-tooltip>
                </v-flex>
                <v-card color="" class="mb-5">
                  <v-card-text>
                    <v-layout wrap>      
                      <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.listeParticipants && listTravauxResult.listeParticipants.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click.stop="dialogueImprimer=true;type='JOURNAL_PARTICIPANT'"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                          </v-tooltip>
                          <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="primary"
                                @click.stop="imprimerModePlan('exel','JOURNAL_PARTICIPANT_EXCEL')"
                                dark
                            >
                              Exporter en Excel
                                <v-icon right>file_upload</v-icon>
                            </v-btn>Excel
                          </v-tooltip>
                        </v-flex>

                        
                      <data-tables :data="listTravauxResult.listeParticipants" style="width:100%;">
                        <el-table-column
                          prop="createdAt"
                          v-if="typeRech != 'recap'"
                          label="Date de saisie"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>

                        <el-table-column
                          prop="dateRapport"
                          v-if="typeRech != 'recap'"
                          label="Date du rapport"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>

                        <el-table-column
                          prop="libTrx"
                          v-if="typeRech != 'recap'"
                          label="Libellé travaux"
                          align="center"
                          width="250"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="tache"
                          v-if="typeRech != 'recap'"
                          label="Libellé de la tâche"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.tache }}</v-chip
                            >
                          </template>
                        </el-table-column>


                        <el-table-column
                          prop="matricule"
                          label="Matricule"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>

                        <el-table-column
                          prop="nomPrenom"
                          label="Nom & Prénom"
                          align="center"
                          width="250"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.nomPrenom }}</v-chip
                            >
                          </template>
                        </el-table-column>
                        
                         <el-table-column
                          prop="fonction"
                          label="Fonction"
                          align="center"
                          width="250"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="entierHeureT"
                          label="Temps de travail (H)"
                          align="center"
                          width="250"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="coutN"
                          label="Taux horaire (XOF / heure)"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="warning"
                              color="warning"
                              >{{new Intl.NumberFormat().format(scope.row.coutN)}}</v-chip
                            >
                          </template>                        
                        </el-table-column>

                        <el-table-column
                          prop="coutT"
                          label="Cout total XOF"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.coutT }}</v-chip
                            >
                          </template>
                        </el-table-column>
                                             
                      </data-tables>

                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card>
              <br/>  
              <v-chip style="border-radius: 16px;" text-color="white" label color="warning">MATÉRIELS ET CARBURANTS</v-chip>            
                <v-card color="" class="mb-5">
                  <v-card-text>

                    <v-layout wrap>
                      <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.listeVehicules && listTravauxResult.listeVehicules.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click.stop="dialogueImprimer=true;type='JOURNAL_VEHICULE'"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                            </v-tooltip>
                            <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="primary"
                                @click.stop="imprimerModePlan('exel','JOURNAL_VEHICULE_EXCEL')"
                                dark
                            >
                              Exporter en Excel
                                <v-icon right>file_upload</v-icon>
                            </v-btn>Excel
                          </v-tooltip>
                        </v-flex>


                        <data-tables :data="listTravauxResult.listeVehicules" style="width:100%;">
                          <el-table-column
                          prop="createdAt"
                          v-if="typeRech != 'recap'"
                          label="Date de saisie"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>

                        <el-table-column
                          prop="dateRapport"
                          v-if="typeRech != 'recap'"
                          label="Date du rapport"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>


                        <el-table-column
                          prop="libTrx"
                          label="Libellé travaux"
                          align="center"
                          width="250"
                        >
                        </el-table-column>
                        <el-table-column
                          v-if="typeRech != 'recap'"
                          prop="tache"
                          label="Libellé de la tâche"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.tache }}</v-chip
                            >
                          </template>
                        </el-table-column>
                       

                        <!-- <el-table-column
                          prop="nomPrenom"
                          label="code engin"
                          align="center"
                          width="250"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.nomPrenom }}</v-chip
                            >
                          </template>
                        </el-table-column>
                         -->

                        <el-table-column
                          prop="libelle"
                          label="Immatriculation / Marque"
                          align="center"
                          width="250"
                          fixed
                        >
                        </el-table-column>

                        
                        <!-- <el-table-column
                          prop="unite"
                          label="Unitée"
                          align="center"
                          width="150"
                        >
                        </el-table-column> -->

                        <el-table-column
                          prop="cptDjour"
                          label="Compteur début"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.cptDjour }}</v-chip
                            >
                          </template>
                          ffff
                        </el-table-column>

                        <el-table-column
                          prop="cptFjour"
                          label="Compteur fin"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="warning"
                              color="warning"
                              >{{ scope.row.cptFjour}}</v-chip
                            >
                          </template>
                        </el-table-column>

                      

                        <el-table-column
                          prop="coutUnitaire"
                          label="Coût unitaire (Jour)"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.coutUnitaire }}</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="nmbreHeur"
                          label="Temps de travail (H)"
                          align="center"
                          width="250"
                        >
                        </el-table-column>

                       

                        <!-- <el-table-column
                          prop="totalN"
                          label="Coût total (XOF)"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{new Intl.NumberFormat().format(scope.row.totalN)}}</v-chip
                            >
                          </template>
                        </el-table-column> -->

                        <el-table-column
                          prop="qte"
                          label="Qté GO"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.qte }}</v-chip
                            >
                          </template>
                        </el-table-column>


                        <el-table-column
                          prop="cout"                        
                          label="Coût GO  XOF"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.cout }}</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="totalN"
                          label="Montant d'utilisation en carburant (XOF)"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{new Intl.NumberFormat().format(scope.row.totalN)}}</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="coutT_utilisation"
                          label="Montant d'utilisation de l'engin (XOF)"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{new Intl.NumberFormat().format(scope.row.coutT_utilisation)}}</v-chip
                            >
                          </template>
                        </el-table-column>

                      </data-tables>

                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card>   
                                
                <br/>       
              <br/>  
              <v-chip style="border-radius: 16px;" text-color="white" label color="warning">JOURNAL DES MATÉRIAUX</v-chip>
              
              <!-- <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.listeMateriels && listTravauxResult.listeMateriels.length >0">
                <v-tooltip top>
                    <v-btn
                        slot="activator"
                        color="orange"
                        @click.stop="dialogueImprimer=true;type='JOURNAL_RAPPORT'"
                        dark> Exporter en Pdf
                        <v-icon right>print</v-icon>
                    </v-btn>Pdf
                </v-tooltip>
              </v-flex> -->
                <v-card color="" class="mb-5">
                  <v-card-text>

                    <v-layout wrap>
                      <v-flex xs12 class="text-xs-right" v-if=" listTravauxResult.listeMateriels && listTravauxResult.listeMateriels.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click="type='JOURNAL_MATERIAUX';dialogueImprimer=true"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                            </v-tooltip>

                            <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="primary"
                                @click="imprimerModePlan('exel','JOURNAL_MATERIAUX_EXCEL')"
                                dark
                            >
                              Exporter en Excel
                                <v-icon right>file_upload</v-icon>
                            </v-btn>Excel
                          </v-tooltip>
                      </v-flex>


                        <data-tables :data="listTravauxResult.listeMateriels" style="width:100%;">
                          <el-table-column
                          prop="createdAt"
                          v-if="typeRech != 'recap'"
                          label="Date de saisie"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>
                        
                        <el-table-column
                          prop="dateRapport"
                          v-if="typeRech != 'recap'"
                          label="Date du rapport"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>


                        <el-table-column
                          prop="libTrx"
                          v-if="typeRech != 'recap'"
                          label="Libellé travaux"
                          align="center"
                          width="500"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="tache"
                          v-if="typeRech != 'recap'"
                          label="Libellé de la tâche"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.tache }}</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="libMat"
                          label="Désignation"
                          align="center"
                          width="250"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.libMat }}</v-chip
                            >
                          </template>
                        </el-table-column>


                        <el-table-column
                          prop="unite"
                          label="Unité"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>

                        
                        <el-table-column
                          prop="qteMat"
                          label="Quantité"
                          align="center"
                          width="250"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.qteMat }}</v-chip
                            >
                          </template>
                        </el-table-column>
                        
                        <el-table-column
                          prop="prix"
                          label="Cout unitaire XOF"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.prix }}</v-chip
                            >
                          </template>
                        </el-table-column>

                        <el-table-column
                          prop="total"
                          label="Coût total XOF"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.total }}</v-chip
                            >
                          </template>
                        </el-table-column>                                              
                      </data-tables>

                
                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card>   
              <br/>  
              <v-chip style="border-radius: 16px;"  v-if="typeRech != 'recap'" text-color="white" label color="warning">JOURNAL DES TRAVAUX</v-chip>            
                <v-card color="" class="mb-5" v-if="typeRech != 'recap'">
                  <v-card-text>

                    <v-layout wrap>
                      <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.listeTaches && listTravauxResult.listeTaches.length >0">
                        <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="orange"
                                @click.stop="dialogueImprimer=true;type='JOURNAL_TACHES'"
                                dark
                            >
                              Exporter en Pdf
                                <v-icon right>print</v-icon>
                            </v-btn>Pdf
                            </v-tooltip>

                            <v-tooltip top>
                            <v-btn
                                slot="activator"
                                color="primary"
                                @click="imprimerModePlan('exel','JOURNAL_TACHES_EXCEL')"
                                dark
                            >
                              Exporter en Excel
                                <v-icon right>file_upload</v-icon>
                            </v-btn>Excel
                          </v-tooltip>
                        </v-flex>


                        <data-tables
                        v-if="typeRech != 'recap'"
                        :data="listTravauxResult.listeTaches"
                        style="width:100%;"
                      >
                      
                      <el-table-column
                          prop="createdAt"
                          v-if="typeRech != 'recap'"
                          label="Date de saisie"
                          align="center"
                          width="150"
                          fixed
                        >
                        </el-table-column>
                        
                        <el-table-column
                          prop="dateRapport"
                          v-if="typeRech != 'recap'"
                          label="Date du rapport"
                          align="center"
                          width="150"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="orange"
                              color="primary"
                              >{{ scope.row.dateRapport }}</v-chip
                            >                           
                          </template>
                        </el-table-column>


                        <el-table-column
                          prop="libTrx"
                          label="Libellé travaux"
                          align="center"
                          width="250"
                        >
                        </el-table-column>
                        <el-table-column
                          prop="tache"
                          label="Libellé de la tâche"
                          align="center"
                          width="250"
                        >
                        <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="warning"
                              >{{ scope.row.tache }}</v-chip
                            >
                          </template>
                        </el-table-column>
                       

                        <el-table-column
                          prop="profil"
                          v-if="typeRech != 'recap'"
                          label="Section"
                          align="center"
                          width="250"
                          fixed
                        >
                          <template slot-scope="scope">
                            <v-chip
                              outline
                              label
                              text-color="primary"
                              color="primary"
                              >{{ scope.row.profil }} - {{ scope.row.auProfil }}</v-chip
                            >
                          </template>
                        </el-table-column>
                        

                        <el-table-column
                          prop="qte"
                          label="Quantité réalisée"
                          align="center"
                          width="250"
                          fixed
                        >
                        </el-table-column>

                        
                        <el-table-column
                          prop="prixHt"
                          label="Prix de revient XOF"
                          align="center"
                          width="250"
                        >
                        </el-table-column>

                        <el-table-column
                          prop="totalMo"
                          label="Dépenses travaux"
                          align="center"
                          width="250"
                        >
                        </el-table-column>
                        
                        <el-table-column
                          prop="commentaire"
                          label="Observation"
                          align="center"
                          width="350"
                        >
                        </el-table-column>


                      </data-tables>

                      <br />
                    </v-layout>
                    <br>
                  </v-card-text>
                </v-card> 
              </v-flex>
              
              <v-chip style="border-radius: 16px;" text-color="white" label color="warning">LISTE DES RAPPORTS JOURNALIERS</v-chip>            
              <v-flex xs12 class="text-xs-right" v-if="listTravauxResult.rapports && listTravauxResult.rapports.length >0">
                <v-tooltip top>
                    <v-btn
                        slot="activator"
                        color="orange"
                        @click.stop="dialogueImprimer=true;type='JOURNAL_RAPPORT'"
                        dark> Exporter en Pdf
                        <v-icon right>print</v-icon>
                    </v-btn>Pdf
                </v-tooltip>

                <v-tooltip top>
                    <v-btn
                        slot="activator"
                        color="primary"
                        @click="imprimerModePlan('exel', 'JOURNAL_RAPPORT_EXCEL')"
                        dark
                    >
                      Exporter en Excel
                        <v-icon right>file_upload</v-icon>
                    </v-btn>Excel
                  </v-tooltip>
              </v-flex>

              <ListeRapportTrx
                  :type="2"
                  :commis="false"
                  :typeInterface= true
                  :rapportPerso = "false"
                  :show="true"
                  :listeRapportTrx="listTravauxResult.rapports"
                  @reloadListeRapport="loadChantierSearch()"
                >
                </ListeRapportTrx>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>


    <!-- MODAL IMPRESSION BDE COMMANDE-->
      <v-dialog v-model="dialogueImprimer" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
          <v-card-text text-xs-center>
              <p align="center">
                <v-btn @click.stop="imprimerModePlan(2)" color="green" dark>
                  Paysage
                  <v-icon right>print</v-icon>
                </v-btn>
                <v-btn icons color="orange" @click.stop="imprimerModePlan(1)" dark>
                  Portrait
                  <v-icon right>print</v-icon>
                </v-btn>
              </p>
          </v-card-text>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
        <v-btn icon @click.native="dialogueImprimer = false" dark class="blue"
          ><v-icon>close</v-icon>
        </v-btn>
    </v-dialog>

    </div>
  </template>
  
  <style>
      .card {
          background-color: #fff;
          border-radius: 10px;
          border: none;
          position: relative;
          margin: 0 auto;
          text-align: center;
          margin-bottom: 30px;
          box-shadow: 0 0.46875rem 2.1875rem rgba(90,97,105,0.1), 0 0.9375rem 1.40625rem rgba(90,97,105,0.1), 0 0.25rem 0.53125rem rgba(90,97,105,0.12), 0 0.125rem 0.1875rem rgba(90,97,105,0.1);
      }
     #appercu{
       position: absolute;
        top: 15px;
        left: 40px;
        display: none;
        width: 40px;
        height: 20px;
     }
     .card h4:hover{
       display: block;
      }
  
      #price{
        border: none;
        position: relative;
        margin: 0 auto;
        text-align: center;
      }
  
      .l-bg-cherry {
          background: linear-gradient(to right, #493240, #f09) !important;
          color: #fff;
      }
  
      .l-bg-blue-dark {
          background: linear-gradient(to right, #373b44, #4286f4) !important;
          color: #fff;
      }
  
      .l-bg-green-dark {
          background: linear-gradient(to right, #0a504a, #38ef7d) !important;
          color: #fff;
      }
  
      .l-bg-red-dark {
          background: linear-gradient(to right, #c71111, #ffba56) !important;
          color: #fff;
      }
      .l-bg-orange-dark {
          background: linear-gradient(to right, #a86008, #ffba56) !important;
          color: #fff;
      }
  
      .card .card-statistic-3 .card-icon-large .fas, .card .card-statistic-3 .card-icon-large .far, .card .card-statistic-3 .card-icon-large .fab, .card .card-statistic-3 .card-icon-large .fal {
          font-size: 110px;
      }
  
      .card .card-statistic-3 .card-icon {
          text-align: center;
          line-height: 50px;
          margin-left: 15px;
          color: #000;
          position: absolute;
          right: -5px;
          top: 20px;
          opacity: 0.1;
      }
  
      .l-bg-cyan {
          background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
          color: #fff;
      }
  
      .l-bg-green {
          background: linear-gradient(135deg, #23bdb8 0%, #43e794 100%) !important;
          color: #fff;
      }
  
      .l-bg-orange {
          background: linear-gradient(to right, #f9900e, #ffba56) !important;
          color: #fff;
      }
  
      .l-bg-red {
          background: linear-gradient(to right, #c71111, #ffba56) !important;
          color: #fff;
      }
  
      .l-bg-cyan {
          background: linear-gradient(135deg, #289cf5, #84c0ec) !important;
          color: #fff;
      }
  </style>
  
  <script>
    var echarts = require('echarts/lib/echarts')
    require('echarts/lib/chart/bar')
    require('echarts/lib/chart/pictorialBar')
    require('echarts/lib/chart/funnel')
    require('echarts/lib/chart/sankey')
    require('echarts/lib/chart/scatter')
    require('echarts/lib/chart/pie')
    require('echarts/lib/component/tooltip')
    require('echarts/lib/component/title')

    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'
    // import * as echarts from 'echarts';
    import ListeRapportTrx from "@/components/rapport/ListeRapportTrx";

    import Loading from "@/components/Loading";
    export default {
    components: { Loading ,
      'v-chart': ECharts,ListeRapportTrx
    },
    name: "DashboardRapport",
    props: {
      show: {
        type: Boolean
      },
      detailProjet: {
        type: Object
      }
    },
    data() {
      return {
        //data general
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
  
        loading: false,
        dialogDetail: false,
        showButonExcel: false,
        dialogueImprimer: false,
        listeProjet: [],
        listeRecherche: [],
        listeRapport : [],
        listeChantier: [],
        listeTravaux: [],
        selectTaches:'',
        listTaches: [],
        typeRech:'',
        listTravauxResult: [],
        listChargeResult: [],
        mntTotalChargeI:0,
        showGraph:false,
        mntTotalChargeD:0,
        mntTotalChargeDE: 0,
        mntTotalChargeMA: 0,
        mntTotalDepense: 0,
        listeBudget: [],
        bilanMensuel: [],
        bilanTravaux: [],
        listeDetail: [],
        helpDemande:[{
              num: "1",
              text:"Somme de toutes les commandes éffectuées"
          },
          {
              num: "2",
              text:"Somme de toutes les demandes de fond éffectuées"
          },
          {
              num: "3",
              text:"Somme de toutes les dépenses indiqué dans le rapport journalier"
          },
          ],
          helpDemandeN:[
          {
              num: "1",
              text:"REDEMENT GLOBAL: Qte tâche / Total durée prévu."
          },          {
              num: "1",
              text:"REDEMENT REEL: Le rendement réel d'une tâche d'un projet par jour: Calculé en divisant le nombre de tâches effectuées par le nombre de jours consacrés à la tâche."
          },          
          {
              num: "2",
              text:"Prix BUDGET: Somme de toutes les commandes effectués pour la tâche."
          },
          {
              num: "3",
              text:"ECART PRIX DE REVIENT: L'écart du prix de revient d'une tâche peut être calculé en soustrayant le coût réel de la tâche à son coût prévu. Par exemple, si le coût prévu pour une tâche était de 100 et que le coût réel était de 120, l'écart du prix de revient serait de 2"
          },
          {
              num: "4",
              text:"ECART REDEMENT: L'écart de rendement d'une tâche d'un projet peut être calculé en soustrayant le rendement réel de la tâche à son rendement attendu. Par exemple, si la tâche a été estimée à prendre 100 heures pour être terminée, mais qu'elle a pris 120 heures, alors l'écart de rendement sera de -20 heures."
          },
          {
              num: "5",
              text:"COUT RELL:Le coût réel d'une tâche d'un projet est le coût final de la réalisation de cette tâche, c'est-à-dire le coût réellement dépensé pour la réaliser."
          }
          ,
          {
              num: "6",
              text:"VALEUR PLANIFIEE: La valeur planifiée d'une tâche d'un projet est le coût estimé de la réalisation de cette tâche."
          }
          
          ],
          listeTypeRech: [{libelle: "RÉCAPITULATIF", id: "recap"},{libelle: "DÉTAILLÉS", id: "details"}],
        //  new data
        selectProjet: [],
        selectChantier: [],
        selectTravaux: [],
        selectAnnee:'',
        libelleTravaux: '',
        selectAnneeFormat:'',
        //critere de recherche
        formTri:{periode:'',},

        compte: "0",
        dialogConfirm: false,
        disabledBtnPop: false,
        totalMntPropose: 0,
        totalMntValide: 0,
      };
    },
  
    computed: {},
    watch: {
      show: function(newValue, oldvalue) {
        this.dialogDetail = newValue;
        if (newValue == true) {
          this.listeBudget = this.detailProjet.budgets;
          let _this = this;
          this.totalMntPropose = 0;
          this.totalMntValide = 0;
          this.totalMntMarche = 0;
          this.listeBudget.forEach(item => {
            this.totalMntPropose += item.mntTotalBudgetPropose;
            this.totalMntValide += item.mntTotalBudgetValide;
          });
          this.loadBilan(this.detailProjet.idProj);
        }
      }
    },
  
    methods: {
      handleTabClick(tab) {
        switch (tab) {
          case "0":
            break;
          case "1":
            break;
  
          default:
            break;
        }
      },
      headerRowStyle({ row, rowIndex }) {
      return { color: "black" };
    },
      statistique(dataStat) {
        var chartDom = document.getElementById('main');        
          var myChart = echarts.init(chartDom);
          var option;

          option = {
            title: {
                text: 'Rapport d\'analyse de la valeur acquise',
              },
              tooltip: {
                  trigger: 'axis',
              },
              legend: {              
                  data: ['VALEUR PLANIFIEE (VP)', 'VALEUR ACQUISE (VA)', 'COUT REEL (CR),']
              },                   
              grid: {
                left: '10%',
                right: '10%',
                bottom: '10%',
                containLabel: true
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: ['Janvier', 'Fevrier', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet','Aout','Septembre','Octobre','Novembre','Decembre']
            },
            yAxis: {
              type: 'value'
            },
            series: [
              {
                name: 'VALEUR PLANIFIEE',
                type: 'line',
                stack: 'Total',
                data: []
              },
              {
                name: 'VALEUR ACQUISE',
                type: 'line',
                stack: 'Total',
                data: []
              },
              {
                name: 'COUT REEL',
                type: 'line',
                stack: 'Total',
                data: []
              }
            ]
          };
          
          let tabNb = option.xAxis.data.length
          for (let i=0; i<tabNb; i++) {
              for(let dataCBud in dataStat){
                let mois =  option.xAxis.data

                if(mois[i] === dataStat[dataCBud]['mois']) {
                  option.series[0].data.push({value:dataStat[dataCBud]['vp'],name: "VALEUR PLANIFIEE (VP)"});
                  option.series[1].data.push({value:dataStat[dataCBud]['va'],name: "VALEUR ACQUISE (VA)"});
                  option.series[2].data.push({value:dataStat[dataCBud]['cr'],name: "COUT REEL (CR)"});
                }                      
            }
          }
          option && myChart.setOption(option);
      },
      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      getSumm(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 4) {
            sums[index] = "N/A";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      closeDialog() {
        this.$emit("close");
      },
      getSummCompte(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
        return sums;
      },
      getSummCompteFinance(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 6) {
            sums[index] = "N/A";
            return;
          }
  
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value))) {
            sums[index] = new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      getSummDetailBudget(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = "Sous total";
            return;
          }
  
          if (index === 5) {
            sums[index] = "N/A";
            return;
          }
          const values = data.map(item => Number(item[column.property]));
      

          if (!values.every(value => isNaN(value))) {
            
            sums[index] = 

            new Intl.NumberFormat().format(
              values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return prev + curr;
                } else {
                  return prev;
                }
              }, 0)
            );
          } else {
            sums[index] = "N/A";
          }
        });
  
        return sums;
      },
      loadBilan(idProjet) {
        this.loading = true;
        let url = this.domaine + "budgetProjet/bilan/projet/" + idProjet;
        this.$http.get(url).then(
          response => {
            this.loading = false;
            this.bilanMensuel = response.body.mensuel;
            this.bilanTravaux = response.body.bilanTravaux.travaux;
            this.listeDetail = response.body.detailCompte;
          },
          errRep => {
            this.loading = false;
            this.$message.error(
              "Une erreur est survenue lors du chargement du bilan"
            );
          }
        );
      },
      loadProjet() {
          let url = this.domaine + "projet/indicateur/projet";

          this.loading = true;
          this.$http.get(url).then(
              response => {
                  this.loading = false;
                  this.listeProjet = response.body.projet;
                  // this.listeRapport = response.body.rapport;
              },
              errRep => {
                  this.loading = false;
                  this.$message.error(
                      "Une erreur est survenue lors du chargement de la liste des projets"
                  );
              }
          );
      },
      loadChantierSearch() {
      this.loading = true;
      this.listTravauxResult = [];
      this.listChantierResult = [];
      if (
        this.selectChantier != "" && this.typeRech != ""
      ) {

        this.listeTravaux.find((item)=>{
              if(item.id == this.selectTravaux) {
                this.libelleTravaux = item.libelle
              }
          })
          let dateSelect = null
          this.selectAnneeFormat = ''              
        let url =
          this.domaine +
          "journal/chantier/"+this.selectChantier+"/travaux/"+(this.selectTravaux ? this.selectTravaux : null)+"/annee/"+(this.selectAnnee ?  this.selectAnnee : null)+'/'+this.typeRech+"/taches/"+(this.selectTaches ? this.selectTaches : null)+ "/rendement";
            this.$http.get(url).then(response => {
                if (response.body) {
                    this.loading = false;      
                    this.listTravauxResult = response.body;
                    this.$notify({
                          title: 'RESULTATS DE VOTRE RECHERCHE',                          
                          type: 'success',
                          position: 'top-center'
                      })
                }
            });
      } else {
        this.$message.error("Assurez-vous d'avoir sélectionner un chantier et un type de recherche");
        this.loading = false;
      }
      },

    loadTravaux() {
      this.loading = true;
      this.listTravaux = [];
      if (this.selectChantier != "" && this.selectChantier != null) {
        let url =
          this.domaine + "projet/" + this.selectChantier + "/index/chantier/travaux";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un chantier");
        this.loading = false;
      }
    },
    loadTaches() {
      this.loading = true;
      this.listTravaux = [];
      if (this.selectTravaux != "" && this.selectTravaux != null) {
        let url =
          this.domaine + "projet/travaux_tache/"+ this.selectTravaux+"/index/tache";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTaches = response.body.tache;
            this.loading = false;
          }
        });
      } else {
        this.$message.error("Veuillez sélectionner un travaux");
        this.loading = false;
      }
    },
    onchangeInfo(projetS){
        this.listeProjet.find((item)=>{
              if(item.id == projetS) {
                this.listeChantier = item.chantier
              }
          })
      },
      onchangeChantier(chantierS) {
        this.listeChantier.find((item)=>{
              if(item.id == chantierS) {
                this.listeTravaux = item.travauxId
              }
          })
      },
      onChangeTravaux(travaux) {
        this.listeTravaux.find((item)=>{
              if(item.idChantier == travaux) {
                this.listTaches = item.travauxId
              }
          })
      },
      imprimerModePlan(mode, type = null){
        console.log('mode',this.type)

        this.type = type ? type : this.type
        console.log('mode',this.type)
        console.log('mode',mode)
        let url = ''
        if(mode =='exel') {  
          url = this.domaine + "journal/chantier/"+this.selectChantier+"/travaux/"+(this.selectTravaux ? this.selectTravaux : null)+"/annee/"+(this.selectAnnee ?  this.selectAnnee : null)+'/'+this.typeRech+"/taches/"+(this.selectTaches ? this.selectTaches : null)+ "/rendement"+'/'+this.user.id+'/'+mode+'/'+this.type;
        }else {
          url = this.domaine + "journal/chantier/"+this.selectChantier+"/travaux/"+(this.selectTravaux ? this.selectTravaux : null)+"/annee/"+(this.selectAnnee ?  this.selectAnnee : null)+'/'+this.typeRech+"/taches/"+(this.selectTaches ? this.selectTaches : null)+ "/rendement"+'/'+this.user.id+'/'+mode+'/'+this.type;
          this.$http.get(url).then(response => {
            if (response.body) {}
          })
          this.dialogueImprimer = false
          this.type = ''
        }
        
      window.open(url)
  },
    },
    mounted() {
      this.loadProjet()
    }
  };
  </script>
  


// WEBPACK FOOTER //
// src/components/rapport/Comparateur_journal.vue